import { FormLayout } from "@careinfo/layout";
import React from "react";
import { useForm } from "react-hook-form";
import ShipviaForm from "./ShipviaForm";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { shipViaValidationForm } from "../../utils/validationSchemas";

const CreateShipvia = (props: any) => {
  const { handleCreate, isLoading } = props;
  const {
    handleSubmit,
    register,
    formState: { errors },
    setError,
    control,
  } = useForm<any>({
    resolver: yupResolver(shipViaValidationForm),
  });

  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <ShipviaForm register={register} errors={errors} control={control} />
    </FormLayout>
  );
};

export default CreateShipvia;
